import { render, staticRenderFns } from "./ModuleMoonPay.vue?vue&type=template&id=d9340f12&scoped=true&"
import script from "./ModuleMoonPay.vue?vue&type=script&lang=js&"
export * from "./ModuleMoonPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9340f12",
  null
  
)

export default component.exports